import requestUtil from '../../../helpers/requestUtil';
import { updateSharedSlice } from '../../shared/sharedSlice';
import { setLoading } from '../Loader/slice';
import * as Toasts from '../Toastify';
import { resetGlopalSearch, setGlopalSearch, setHeaderState, userNotifyList } from './slice';

export const updateGlopalSearch = (search,locationValue,distanceValue) => {
  return async (dispatch) => {
    dispatch(setGlopalSearch({search,locationValue,defaultDistance:distanceValue}));
  };
};

export const clearGlopalSearch = () => {
  return async (dispatch) => {
    dispatch(resetGlopalSearch());
  };
};

export function getUserNotifyList(url, userNotifyJson) {
  return async (dispatch) => {
    dispatch(setLoading(true));
    requestUtil(`${url}/Notify/get-user-notify-list`, 'POST', userNotifyJson)
      .then((response) => {
        dispatch(setUserNotifyList(response));
        dispatch(setLoading(false));
      })
      .catch((error) => {
        dispatch(setLoading(false));
      });
  };
}

export const setUserNotifyList = (data) => {
  return async (dispatch) => {
    dispatch(userNotifyList(data));
  };
};

export const saveUserNotifyList = (url, userNotifyJson) => {
  return async (dispatch) => {
    dispatch(setLoading(true));
    requestUtil(`${url}/Notify/mark-read-user-notify?FeatureNotifyId=${userNotifyJson?.featuresNotifyId}`, 'POST', userNotifyJson)
      .then((response) => {
        Toasts.success(response.message);
        dispatch(setLoading(false));
      })
      .catch((error) => {
        dispatch(setLoading(false));
      });
  };
};


export const getLocationList = ({baseUrl,empID}) => {
  return async(dispatch,getState) => {
    const state = getState();
    const locationSharedList = state.shared.locationSharedList;
    let location = locationSharedList ?? [];
    dispatch(setLoading(true));
    try {
       if(location?.length === 0){
        location = await requestUtil(`${baseUrl}/Locations/get-location-list-for-dropdown/${empID}`);
        dispatch(updateSharedSlice({name:"locationSharedList",value:location}));
       }
      dispatch(setHeaderState({name:"locationMasterList",value:location}));
      return location;
    } catch (error) {
      return error.message
    } finally{
      dispatch(setLoading(false));
    }
  }
}
export const getLocationDistanceList = ({baseUrl,employerId,employerUniqueId}) => {
  return async(dispatch) => {
    dispatch(setLoading(true));
    try {
       const response = await  requestUtil(`${baseUrl}/Locations/getlocationlist`, "POST", 
      {
          "page": 0,
          "pageSize": 0,
          "sortOrder": "string",
          "sortColumn": "string",
          "employerId": employerId,
          "employerUniqueId": employerUniqueId,
          "searchText": 0
      });;
      const result = response?.locations?.length ? response?.locations :[]
      dispatch(setHeaderState({name:"locationDistanceList",value:result}));
      return result;
    } catch (error) {
      return error.message
    } finally{
      dispatch(setLoading(false));
    }
  }
}